'use client'

import React, { createContext, useContext, useState, useCallback } from 'react'

export type PricingPeriod = 'hourly' | 'monthly'

interface PricingToggleContextType {
  pricingPeriod: PricingPeriod
  setPricingPeriod: (period: PricingPeriod) => void
  togglePricingPeriod: () => void
}

const PricingToggleContext = createContext<PricingToggleContextType | undefined>(undefined)

export const PricingToggleProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [pricingPeriod, setPricingPeriod] = useState<PricingPeriod>('hourly')

  const togglePricingPeriod = useCallback(() => {
    setPricingPeriod((prev) => (prev === 'hourly' ? 'monthly' : 'hourly'))
  }, [])

  return (
    <PricingToggleContext.Provider
      value={{
        pricingPeriod,
        setPricingPeriod,
        togglePricingPeriod,
      }}
    >
      {children}
    </PricingToggleContext.Provider>
  )
}

export const usePricingToggle = (): PricingToggleContextType => {
  const context = useContext(PricingToggleContext)
  if (!context) {
    throw new Error('usePricingToggle must be used within a PricingToggleProvider')
  }
  return context
}
